import { fetchData } from '@/utils/fetch'

const state = {
  cartCount: 0
}

const mutations = {
  SET_CART_COUNT (state, count) {
    state.cartCount = count
  }
}

const actions = {
  updateCartCount: async ({ state, commit }) => {
    const { code, data } = await fetchData('/appb/b2b/cart/cartCount')
    if (code === 200) {
      commit('SET_CART_COUNT', data)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
